import React from 'react';

interface MenuProps {
  children: React.ReactNode;
}

export const Menu: React.FC<MenuProps> = ({ children }) => {
  return (
    <nav className="bg-white pt-6 min-w-32 h-screen">
      <ul>{children}</ul>
    </nav>
  );
};
